var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgElement2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4021 18.0018C49.2063 18.0018 58.7755 27.571 58.7755 39.3753C58.7755 51.1795 49.2063 60.7487 37.4021 60.7487C25.5979 60.7487 16.0287 51.1795 16.0287 39.3753C16.0287 27.571 25.5979 18.0018 37.4021 18.0018ZM37.4021 4.8843C56.4509 4.8843 71.8931 20.3264 71.893 39.3753C71.893 58.4241 56.4509 73.8662 37.4021 73.8662C18.3533 73.8662 2.91113 58.4241 2.91114 39.3753C2.91114 20.3264 18.3533 4.8843 37.4021 4.8843Z",
    fill: "url(#paint0_linear_10848_6516)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2409 37.4449C14.2409 24.6297 24.6296 14.241 37.4447 14.241C50.2599 14.241 60.6486 24.6297 60.6486 37.4449C60.6486 50.26 50.2599 60.6487 37.4447 60.6487C24.6296 60.6487 14.2409 50.26 14.2409 37.4449ZM-5.19997e-05 37.4449C-5.01918e-05 16.7647 16.7646 6.17156e-05 37.4447 6.35235e-05C58.1249 6.53315e-05 74.8895 16.7647 74.8895 37.4449C74.8895 58.125 58.1249 74.8896 37.4447 74.8896C16.7645 74.8896 -5.38076e-05 58.125 -5.19997e-05 37.4449Z",
    fill: "url(#paint1_linear_10848_6516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10848_6516",
    x1: 185.602,
    y1: 84.6146,
    x2: 185.602,
    y2: -91.8668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10848_6516",
    x1: 65.9897,
    y1: 61.4893,
    x2: 11.9897,
    y2: 15.4893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElement2);
export default __webpack_public_path__ + "static/media/bg_element2.37cfcfbb402dcf630264cad8a034b4bb.svg";
export { ForwardRef as ReactComponent };